import React, { FC } from "react";
import "../intakeFormSteps.scss";

export const CheckIcon: FC = () => (
  <svg
    width="10"
    height="8"
    viewBox="0 0 14 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 5L5 9L13 1"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

interface InlineCheckboxProps {
  id: string;
  label: string | React.ReactNode;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

const InlineCheckbox: FC<InlineCheckboxProps> = ({
  id,
  label,
  checked,
  onChange,
}) => (
  <div className="intake-form-step__inline-checkbox">
    <label className="intake-form-step__inline-checkbox__label" htmlFor={id}>
      <input
        type="checkbox"
        id={id}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="intake-form-step__inline-checkbox__input"
      />
      <span className="intake-form-step__inline-checkbox__checkmark">
        {checked && <CheckIcon />}
      </span>
      <span className="intake-form-step__inline-checkbox__text">{label}</span>
    </label>
  </div>
);

export default InlineCheckbox;
